import React, { useEffect, useMemo, useRef, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import CreateTripsStickyHeader from "../components/Create/StickyHeader";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { getValue } from "@utils/lodash";
import {
  createTrip,
  getAllTripForm,
  getAllTripFormEdit,
  getTripValidateApproverFlowType,
  submitTrip,
  updateTrip,
} from "@services/trips.service";
import { RenderForm } from "@components/common/FormBuilder/render-form";
import TripsCreateHeader from "../components/Create/tripsHeader";
import TripsCreateFlightList from "../components/Create/Flight/flight-section";
import { toast } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";
import {
  concatString,
  formatText,
  removeEmptyProperties,
  removeNullOrUndefinedProperties,
  sortJSONObjectArray,
} from "@common/text-helpers";
import {
  FormAppendDataRequestHelper,
  FormRequestHelper,
} from "@components/common/FormBuilder/request-helper";
import {
  QueryRequestHelper,
  removeNullInObject,
} from "@common/query-request-helper";
import ReportSubmitModal from "@components/Reports/components/ReportSubmitPopup";
import TripCreateHotelSection from "../components/Create/hotel/hotel-section";
import TripCreateCarSection from "../components/Create/car/car-section";
import TripCreateTrainSection from "../components/Create/train/train-section";
import TripCreateBusSection from "../components/Create/bus/bus-section";
import { getAllCurrency } from "@services/currency.service";
import TripsTabNavigation from "./tab-navigation";
import {
  generateBusPayload,
  generateCarPayload,
  generateFlightCreatePayload,
  generateHotelPayload,
  generatePrefillTripRequest,
  generateTrainPayload,
} from "./trip-request";
import { useLocation } from "react-router-dom";
import Loader from "@components/common/Loader";
import NoAccessPage from "@components/common/NoAccess";
import { airTravelClass, travelType } from "@common/constants";
import {
  getAllTravelDocuments,
  getAllTravelDocumentsUser,
} from "@services/settings.service";
import { get } from "@services/helpers/http-handler";
import { convertDateAsString } from "@common/date-helpers";
import { NavLink } from "react-router-dom";
import DragAndDropFileComponent from "@common/FileUpload/file-drag-drop";
import { mediaUpload } from "@services/upload.service";
import DocumentImageList from "@common/FileUpload/document-image-list";
import FileLogSvgComponent from "@assets/svg-components/file-log";
import DeleteSvgComponent from "@assets/svg-components/delete";
import SubmitConfirmModal from "@common/popup/SubmitConfirmModal";
import SubmitConfirmModalWithComments from "@common/popup/SubmitConfirmModalWithComments";
import { getMyProfile } from "@services/users.service";
import SingleSelectSearchDropdown from "@components/common/CustomSearchableDropdown/SingleSelectSearchDropdown";
import { usersSearchableDropdown } from "@components/common/CustomSearchableDropdown/SearchAPIs";

interface TravelDocumentsUser {
  passport: Document[];
  visa: Document[];
}

interface Document {
  id: string;
  document_type: string;
  document_expires_on: string;
  // Add other properties as needed
}

function ClientTripsCreate(props: any) {
  let navigate = useNavigate();
  let params = useParams();
  let location = useLocation();
  const [formOptions, setFormOptions] = useState<any>({});
  const urlSearchParams = new URLSearchParams(window.location.search);
  const urlParams = Object.fromEntries(urlSearchParams.entries());
  const createdForFromURL = urlParams.created_for;
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState(0);
  const [isCurrentUserSubmitter, setIsCurrentUserSubmitter] = useState(false);
  const [createdByData, setCreatedByData] = useState<any>(null);
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const [isLoading, setIsLoading] = React.useState(true);
  const [form, setForm] = useState([]);
  const [request, setRequest] = useState({
    air_travel_type: "one_way",
    class: "",
    time_preference: "",
    seat_type: "",
    meal_type: "",
  });
  const [itineraries, setItenaries] = useState([]);
  const [hotelItenaries, setHotelItenaries] = useState([]);
  const [carItenaries, setCarItenaries] = useState([]);
  const [trainItenaries, setTrainItenaries] = useState([]);
  const [busItenaries, setBusItenaries] = useState([]);
  const [flightPreference, setFlighPreference] = useState<any>([]);
  const [documents, setDocuments] = useState<any>([]);
  const [tripComments, setTripComments] = useState("");

  const [userProfile, setUserProfile] = useState<any>({});
  const [createdFor, setCreatedFor] = useState<any>(null);
  const [createdForOptions, setCreatedForOptions] = useState([
    { id: "self", label: "Self" },
  ]);
  const isEditMode = () => {
    return !!getValue(params, `id`, "");
  };

  const getUserProfileData = async () => {
    try {
      let resp = await getMyProfile("");
      if (resp) {
        const profileData = getValue(resp, `data`, {});
        setUserProfile(profileData);

        await getDelegatedUsersWithUserId(getValue(profileData, `id`, ""));

        if (createdForFromURL && createdForFromURL !== "self") {
          setTimeout(() => {
            setCreatedForOptions((prevOptions) => {
              const matchingOption = prevOptions.find(
                (option) => option.id === createdForFromURL,
              );
              if (matchingOption) {
                setCreatedFor(matchingOption);
              } else {
                setCreatedFor({ id: "self", label: "Self" });
              }
              return prevOptions;
            });
          }, 100);
        } else {
          setCreatedFor({ id: "self", label: "Self" });
        }
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };
  const getDelegatedUsersWithUserId = async (userId: string | number) => {
    if (!userId) return;

    try {
      const userIdNumber =
        typeof userId === "string" ? parseInt(userId, 10) : userId;

      console.log("Calling delegated users API with userId:", userIdNumber);

      const delegatedUsers = await usersSearchableDropdown(
        "",
        "",
        userIdNumber,
      );

      console.log("Delegated users response:", delegatedUsers);

      if (delegatedUsers && delegatedUsers.length > 0) {
        const delegatedOptions = delegatedUsers.map((user: any) => ({
          id: String(getValue(user, `id`, "")),
          label: getValue(user, `label`, ""),
        }));

        setCreatedForOptions([
          { id: "self", label: "Self" },
          ...delegatedOptions,
        ]);
      } else {
        setCreatedForOptions([{ id: "self", label: "Self" }]);
      }
    } catch (error) {
      console.error("Error fetching delegated users:", error);
      setCreatedForOptions([{ id: "self", label: "Self" }]);
    }
  };

  useEffect(() => {
    getUserProfileData();
  }, []);

  useEffect(() => {
    if (
      userProfile &&
      getValue(userProfile, `id`, "") &&
      props.permissionAPITriggered
    ) {
      getDefaultData();
      getData();
    }
  }, [props.permissionAPITriggered, userProfile]);
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    if (props.permissionAPITriggered) {
      getDefaultData();
      getData();
    }
  }, [props.permissionAPITriggered]);

  const travelTypeField: any = useMemo(() => {
    return form.find((field: any) => field.field_name === "travel_type");
  }, [form]);

  useEffect(() => {
    if (travelTypeField && travelTypeField.field_value) {
      getTravelTypeData();
    } else if (travelTypeField && !travelTypeField.field_value) {
      setFlighPreference(airTravelClass);
    }
  }, [travelTypeField?.field_value]);

  useEffect(() => {
    const getDestinationCountryValue = (form: any) => {
      const destinationField = form.find(
        (item_form: any) => item_form.field_name === "destination_country",
      );
      return destinationField?.field_value || "";
    };

    const destinationValue = getDestinationCountryValue(form);
    if (destinationValue) {
      getTravelDocumentUser(destinationValue);
      getPassportDetails();
    }
  }, [form]);

  const [tripLimit, setTripLimit] = useState({});
  const getTravelTypeData = async () => {
    const travelTypeValue: any = travelTypeField.field_value;
    try {
      let resp = await getAllTripForm("");
      setTripLimit(getValue(resp, `data.trip_limit`, {}));
      const flightOptions = [];
      const flightLimit = getValue(resp, `data.flight_limit`, "").find(
        (flight: any) => flight.travel_type === travelTypeValue,
      );

      if (flightLimit) {
        if (flightLimit.economy) {
          flightOptions.push({
            value: "economy",
            label: formatText("economy"),
          });
        }
        if (flightLimit.premium_economy) {
          flightOptions.push({
            value: "premium_economy",
            label: formatText("premium_economy"),
          });
        }
        if (flightLimit.business) {
          flightOptions.push({
            value: "business",
            label: formatText("business"),
          });
        }
        if (flightLimit.first) {
          flightOptions.push({ value: "first", label: formatText("first") });
        }
      }

      if (!getValue(resp, `data.trip_limit.is_active`, false)) {
        setFlighPreference(airTravelClass);
      } else {
        setFlighPreference(flightOptions);
      }

      console.log("Travel type field:", travelTypeField);
    } catch (error) {
      console.error("Error fetching travel type data", error);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const [travelModes, setTravelModes] = useState({});
  const getDefaultData = async () => {
    try {
      let resp: any = await getAllTripForm("");
      if (resp) {
        setTravelModes(getValue(resp, `data.travel_modes`, []));

        // Store the complete form options including custom lists
        const completeFormOptions = {
          custom_list: {},
          ...getValue(resp, `data`, {}),
        };

        // Extract custom field data
        Object.keys(resp.data).forEach((key) => {
          if (key.startsWith("t-custom-list-")) {
            completeFormOptions.custom_list[key] = resp.data[key];
          }
        });

        setFormOptions(completeFormOptions);

        let arr = getValue(resp, `data.form_layout`, []).map((item: object) => {
          if (getValue(item, `field_name`, "") === "currency") {
            return {
              ...item,
              field_name: "currency_id",
            };
          } else {
            return {
              ...item,
            };
          }
        });
        setForm(arr);
      }
    } catch (error) {
      console.error("Error fetching default data:", error);
    }
  };

  const getData = async () => {
    if (getValue(params, `id`, "")) {
      try {
        setIsLoading(true);
        let resp: any;
        if (getValue(params, `id`, "")) {
          resp = await getAllTripFormEdit(getValue(params, `id`, ""));
        } else {
          resp = await getAllTripForm("");
        }
        if (resp) {
          // Store form options including custom lists
          const completeFormOptions = {
            custom_list: {},
            ...getValue(resp, `data`, {}),
          };

          Object.keys(resp.data).forEach((key) => {
            if (key.startsWith("t-custom-list-")) {
              completeFormOptions.custom_list[key] = resp.data[key];
            }
          });

          setFormOptions(completeFormOptions);

          if (getValue(params, `id`, "")) {
            setForm(getValue(resp, `data.form_layout`, []));
            let length = getValue(resp, `data.form_layout.length`, 0);
            let array = getValue(resp, `data.form_layout`, []).filter(
              (item: object) => getValue(item, `is_visible`, false),
            );
            let payload = {
              currency_code: getValue(resp, `data.trip.claimed_currency`, ""),
            };
            let queryRequest = QueryRequestHelper(payload);
            let trip = getValue(resp, `data.trip`, {});

            if (getValue(trip, `attachments`, null)) {
              setDocuments(
                getValue(trip, `attachments`, null)
                  ?.filter((a: { type: string }) => a.type === "others")
                  ?.flatMap(
                    (a: { documents: any[] }) =>
                      a.documents?.map((d: { id: any }) => d) ?? [],
                  ) ?? [],
              );
            }

            // Handle submitted_by logic
            if (getValue(params, `id`, "")) {
              const submittedBy = getValue(trip, `submitted_by`, null);
              const createdBy = getValue(trip, `created_by`, null);
              const currentUserId = getValue(userProfile, `id`, "");

              if (submittedBy && createdBy) {
                const submittedById = getValue(submittedBy, `id`, "");
                const createdById = getValue(createdBy, `id`, "");

                // Check if current user is the submitter
                if (currentUserId && submittedById === currentUserId) {
                  setIsCurrentUserSubmitter(true);

                  // Set created_by data for display
                  const createdByOption = {
                    id: String(createdById),
                    label: `${getValue(createdBy, `first_name`, "")} ${getValue(
                      createdBy,
                      `last_name`,
                      "",
                    )}`.trim(),
                  };

                  setCreatedByData(createdByOption);
                  setCreatedFor(createdByOption);

                  // Add created_by to options if not already present
                  setCreatedForOptions((prevOptions) => {
                    const existingIds = prevOptions.map((option) => option.id);
                    if (!existingIds.includes(createdByOption.id)) {
                      return [...prevOptions, createdByOption];
                    }
                    return prevOptions;
                  });
                } else {
                  // Current user is not the submitter, show submitted_by as created for
                  setIsCurrentUserSubmitter(false);

                  const submittedByOption = {
                    id: String(submittedById),
                    label: `${getValue(
                      submittedBy,
                      `first_name`,
                      "",
                    )} ${getValue(submittedBy, `last_name`, "")}`.trim(),
                  };

                  setCreatedFor(submittedByOption);

                  setCreatedForOptions((prevOptions) => {
                    const existingIds = prevOptions.map((option) => option.id);
                    if (!existingIds.includes(submittedByOption.id)) {
                      return [...prevOptions, submittedByOption];
                    }
                    return prevOptions;
                  });
                }
              }
            }

            getInfo(trip);

            if (getValue(resp, `data.trip.claimed_currency`, "")) {
              let currency = await getAllCurrency(queryRequest);
              if (currency) {
                trip["currency"] = {
                  id: getValue(currency, `data.data[${0}].id`, ""),
                };
              }
            }

            for (let i = 0; i < length; i++) {
              FormAppendDataRequestHelper(array[i], trip);
            }
            setForm(array);
          } else {
            setForm(getValue(resp, `data.form_layout`, []));
          }

          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        console.error("Error in getData:", error);
      }
    } else {
      setIsLoading(false);
    }
  };
  const getInfo = async (resp: any) => {
    const {
      flightTrips,
      flightItineraries,
      hotelItineraries,
      carItineraries,
      trainItineraries,
      busItineraries,
    } = generatePrefillTripRequest(resp);
    setRequest({
      ...request,
      air_travel_type: getValue(flightTrips, `[${0}].air_travel_type`, ""),
      class: getValue(flightTrips, `[${0}].flight.class`, ""),
      seat_type: getValue(flightTrips, `[${0}].flight.seat_type`, ""),
      meal_type: getValue(flightTrips, `[${0}].flight.meal_type`, ""),
    });
    setItenaries(flightItineraries);
    setHotelItenaries(hotelItineraries);
    setCarItenaries(carItineraries);
    setTrainItenaries(trainItineraries);
    setBusItenaries(busItineraries);
  };

  /* -------------------------------------------------------------------------- */
  /*                         Travel Document section                            */
  /* -------------------------------------------------------------------------- */
  // const [travelDoucmentsUser, setTravelDocumentsUser] = useState([]);
  const [travelDocumentsUser, setTravelDocumentsUser] =
    useState<TravelDocumentsUser | null>(null);

  const [passportDetails, setPassportDetails] = React.useState<[]>([]);
  const getTravelDocumentUser = async (id: string) => {
    try {
      let payload = {
        country_id: String(id),
        ...(createdForFromURL ? { user_id: createdForFromURL } : {}),
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getAllTravelDocumentsUser(queryRequest);
      if (resp) {
        setTravelDocumentsUser(getValue(resp, `data`, []));
      }
    } catch (error) {}
  };

  const getPassportDetails = async () => {
    try {
      let payload: any = {
        filter_type: "passport",
        document_type: "active",
        ...(createdForFromURL ? { user_id: createdForFromURL } : {}),
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getAllTravelDocuments(queryRequest);
      if (resp) {
        const travel_documents = getValue(resp, `data.travel_documents`, []);
        console.log(travel_documents, "travel_documents");

        const primary_document = travel_documents.filter(
          (d: any) => d.document_primary,
        );
        if (primary_document.length > 0) {
          setPassportDetails(primary_document[0]);
        } else {
          travel_documents && setPassportDetails(travel_documents[0]);
        }

        console.log(resp, primary_document, "primary_document");
      }
    } catch (error) {}
  };
  /* -------------------------------------------------------------------------- */
  /*                               Submit Section                               */
  /* -------------------------------------------------------------------------- */
  const [submitLoading, setSubmitLoading] = useState(false);
  const [checkMandatoryModules, setCheckMandatoryModules] = useState({});
  const handleSubmit = async () => {
    // const formValid = simpleValidator.current.allValid();
    const travelTypeValue = getValue(travelTypeField, `field_value`, "");
    const destinationCountryField = form.find(
      (item: any) => getValue(item, `field_name`, "") === "destination_country",
    );
    const destinationCountryLabel = getValue(
      destinationCountryField || {},
      `display_name`,
      "Destination Country",
    );
    const errorMessages = simpleValidator.current.errorMessages;
    const relevantErrors = Object.entries(errorMessages).filter(
      ([label, msg]) =>
        msg !== null &&
        msg !== undefined &&
        msg !== "" &&
        !(
          travelTypeValue !== "international" &&
          label === destinationCountryLabel
        ),
    );

    const formValid = relevantErrors.length === 0;

    // Check if itineraries exist
    if (
      (!itineraries || itineraries.length === 0) &&
      (!hotelItenaries || hotelItenaries.length === 0) &&
      (!carItenaries || carItenaries.length === 0) &&
      (!trainItenaries || trainItenaries.length === 0) &&
      (!busItenaries || busItenaries.length === 0)
    ) {
      toast.error(
        "Itineraries cannot be empty. Please add at least one itinerary.",
      );
      return;
    }

    // Validate flight seat and meal preferences if flights exist
    if (itineraries && itineraries.length > 0) {
      const invalidFlightPreferences = validateFlightPreferences(
        itineraries,
        request,
        travelModes,
      );
      if (invalidFlightPreferences.length > 0) {
        toast.error(
          "Seat preference and meal preference are mandatory for all flight bookings. Please complete all flight preferences.",
        );
        return;
      }
    }

    if (!formValid) {
      const mandatoryFields = checkMandatoryFields();
      setCheckMandatoryModules({});
      setTimeout(() => {
        setCheckMandatoryModules(mandatoryFields);
      }, 0);

      simpleValidator.current.showMessages();
      forceUpdate(1);
    } else {
      try {
        setSubmitLoading(true);
        let resp;
        let form_payload = FormRequestHelper(form);
        let flight = generateFlightCreatePayload(
          getValue(request, `air_travel_type`, ""),
          itineraries,
          request,
        );
        let hotel = generateHotelPayload(hotelItenaries);
        let car = generateCarPayload(carItenaries, params);
        let train = generateTrainPayload(trainItenaries, params);
        let bus = generateBusPayload(busItenaries, params);
        let array = flight.concat(hotel, car, train, bus);

        // Validate multi-city flight details
        const multiCityFlights = array.filter(
          (item: any) =>
            item.travel_mode === "flight" &&
            item.air_travel_type === "multi_city",
        );

        for (let i = 0; i < multiCityFlights.length; i++) {
          for (let j = i + 1; j < multiCityFlights.length; j++) {
            const flight1 = multiCityFlights[i].flight;
            const flight2 = multiCityFlights[j].flight;

            if (
              flight1.departure_airport_code ===
                flight2.departure_airport_code &&
              flight1.arrival_airport_code === flight2.arrival_airport_code &&
              flight1.departure_date === flight2.departure_date &&
              flight1.arrival_date === flight2.arrival_date &&
              flight1.time_preference === flight2.time_preference
            ) {
              toast.error(
                "The multi-city flights have the same travel details. Please update the itinerary.",
              );
              setSubmitLoading(false);
              return;
            }
          }
        }

        // Check if there are any multi-city flights
        if (multiCityFlights.length > 0) {
          // Ensure at least 2 flight itineraries for multi-city
          if (multiCityFlights.length < 2) {
            toast.error(
              "Multi-city travel requires at least two flight itineraries.",
            );
            setSubmitLoading(false);
            return;
          }
        }

        // Keep the existing duplicate check for multi-city flights
        for (let i = 0; i < multiCityFlights.length; i++) {
          for (let j = i + 1; j < multiCityFlights.length; j++) {
            const flight1 = multiCityFlights[i].flight;
            const flight2 = multiCityFlights[j].flight;

            if (
              flight1.departure_airport_code ===
                flight2.departure_airport_code &&
              flight1.arrival_airport_code === flight2.arrival_airport_code &&
              flight1.departure_date === flight2.departure_date &&
              flight1.arrival_date === flight2.arrival_date &&
              flight1.time_preference === flight2.time_preference
            ) {
              toast.error("Duplicate flight details in multi-city itinerary");
              setSubmitLoading(false);
              return;
            }
          }
        }

        const invalidHotels = validateHotels(array);

        if (invalidHotels.length > 0) {
          toast.error(
            "Checkout time should not be earlier than or equal to checkin time in hotel itineraries.",
          );
          setSubmitLoading(false);
          return;
        }

        const invalidCars = validateCars(array);

        if (invalidCars.length > 0) {
          toast.error(
            "Drop Off time must be after Pick Up time. Please check your car rental details.",
          );
          setSubmitLoading(false);
          return;
        }

        // **Train Validation**
        const invalidTrains = array.filter(
          (item: any) =>
            item.travel_mode === "train" &&
            item.train.departure_city === item.train.arrival_city,
        );

        if (invalidTrains.length > 0) {
          toast.error(
            "Departure city and arrival city should not be the same in train itineraries.",
          );
          setSubmitLoading(false);
          return;
        }

        // **Bus Validation**
        const invalidBus = array.filter(
          (item: any) =>
            item.travel_mode === "bus" &&
            item.bus.departure_city === item.bus.arrival_city,
        );

        if (invalidBus.length > 0) {
          toast.error(
            "Departure city and arrival city should not be the same in Bus itineraries.",
          );
          setSubmitLoading(false);
          return;
        }

        let payload = {
          ...form_payload,
          trip_documents: documents.map((doc: { id: string }) => doc.id),
          itineraries: removeEmptyProperties(array),
        };

        if (
          !isEditMode() &&
          createdFor &&
          getValue(createdFor, `id`, "") !== "self"
        ) {
          payload.submitted_for = Number(getValue(createdFor, `id`, ""));
        }
        if (getValue(params, `id`, "")) {
          resp = await updateTrip(
            getValue(params, `id`, ""),
            removeNullInObject(payload),
          );
        } else {
          resp = await createTrip(removeNullInObject(payload));
        }
        if (resp) {
          toast.success(getValue(resp, `message`, ""));
          navigate(
            getValue(params, `id`, "")
              ? `/client/trips/detail/${getValue(params, `id`, "")}`
              : `/client/trips/`,
          );
          hideValidation();
        } else {
          setSubmitLoading(false);
        }
      } catch (error) {
        setSubmitLoading(false);
      }
    }
  };

  const [tripLoading, setTripLoading] = useState(false);
  // const validateHotels = (array:any) => {
  //   const invalidHotels = array.filter((item:any) => {
  //     if (item.travel_mode !== "hotel") return false;

  //     const hotel = item.hotel;
  //     const checkinDate = new Date(hotel.checkin_date);
  //     const checkoutDate = new Date(hotel.checkout_date);

  //     // Debug logging - helps track the issue
  //     console.log("Hotel validation:", {
  //       hotelName: hotel.hotel_name,
  //       checkinDate: checkinDate.toISOString(),
  //       checkoutDate: checkoutDate.toISOString()
  //     });

  //     // First compare dates (different days)
  //     if (checkoutDate < checkinDate) {
  //       console.log("Checkout date is before checkin date");
  //       return true;
  //     } else if (checkoutDate.getTime() === checkinDate.getTime()) {
  //       // When dates are the same day, we need to compare times
  //       // Ensure we're working with properly formatted time strings
  //       const checkinTimeStr = typeof hotel.checkin_time === 'string' ? hotel.checkin_time : '00:00';
  //       const checkoutTimeStr = typeof hotel.checkout_time === 'string' ? hotel.checkout_time : '00:00';

  //       // Create Date objects with the same date but different times
  //       const baseDate = new Date(checkinDate);
  //       baseDate.setHours(0, 0, 0, 0); // Reset to start of day

  //       const [checkinHours, checkinMinutes] = checkinTimeStr.split(':').map(Number);
  //       const [checkoutHours, checkoutMinutes] = checkoutTimeStr.split(':').map(Number);

  //       const checkinTimeMs = (checkinHours * 60 * 60 + checkinMinutes * 60) * 1000;
  //       const checkoutTimeMs = (checkoutHours * 60 * 60 + checkoutMinutes * 60) * 1000;

  //       // Debug logging - examine parsed time values
  //       console.log("Same-day time comparison:", {
  //         checkinTimeStr,
  //         checkoutTimeStr,
  //         checkinTimeMs,
  //         checkoutTimeMs,
  //         isInvalid: checkoutTimeMs <= checkinTimeMs
  //       });

  //       // On same day, checkout time must be after checkin time
  //       return checkoutTimeMs <= checkinTimeMs;
  //     }

  //     return false;
  //   });

  //   // Log all invalid hotels for debugging
  //   if (invalidHotels.length > 0) {
  //     console.log("Found invalid hotels:", invalidHotels);
  //   }

  //   return invalidHotels;
  // };

  const validateHotels = (array: any) => {
    const invalidHotels = array.filter((item: any) => {
      if (item.travel_mode !== "hotel") return false;

      const hotel = item.hotel;

      let checkinDate: Date | null = null,
        checkoutDate: Date | null = null;
      let checkinTime: Date | null = null,
        checkoutTime: Date | null = null;

      // Parse check-in date and time
      if (typeof hotel.checkin_date === "string") {
        checkinDate = new Date(hotel.checkin_date);
      }
      if (typeof hotel.checkin_time === "string" && checkinDate) {
        if (hotel.checkin_time.includes("T")) {
          checkinTime = new Date(hotel.checkin_time);
        } else {
          const [hours, minutes] = hotel.checkin_time.split(":").map(Number);
          checkinTime = new Date(checkinDate);
          checkinTime.setHours(hours, minutes, 0, 0);
        }
      }

      // Parse check-out date and time
      if (typeof hotel.checkout_date === "string") {
        checkoutDate = new Date(hotel.checkout_date);
      }
      if (typeof hotel.checkout_time === "string" && checkoutDate) {
        if (hotel.checkout_time.includes("T")) {
          checkoutTime = new Date(hotel.checkout_time);
        } else {
          const [hours, minutes] = hotel.checkout_time.split(":").map(Number);
          checkoutTime = new Date(checkoutDate);
          checkoutTime.setHours(hours, minutes, 0, 0);
        }
      }

      // Ensure dates are valid before using them
      if (!checkinDate || !checkoutDate || !checkinTime || !checkoutTime) {
        console.error(
          "Invalid date/time detected for hotel:",
          hotel.hotel_name,
        );
        return true;
      }

      // Create full date-time objects
      const fullCheckinDateTime = new Date(checkinDate);
      fullCheckinDateTime.setHours(
        checkinTime.getHours(),
        checkinTime.getMinutes(),
        0,
        0,
      );

      const fullCheckoutDateTime = new Date(checkoutDate);
      fullCheckoutDateTime.setHours(
        checkoutTime.getHours(),
        checkoutTime.getMinutes(),
        0,
        0,
      );

      // console.log("Processed hotel dates and times:", {
      //   hotelName: hotel.hotel_name || "Unknown hotel",
      //   checkinDate: fullCheckinDateTime.toISOString(),
      //   checkoutDate: fullCheckoutDateTime.toISOString(),
      //   isInvalid: fullCheckoutDateTime <= fullCheckinDateTime,
      // });

      return fullCheckoutDateTime <= fullCheckinDateTime;
    });

    return invalidHotels;
  };
  const validateFlightPreferences = (
    itineraries: any[],
    request: any,
    travelModes: any,
  ) => {
    if (!itineraries || itineraries.length === 0) {
      return [];
    }

    const invalidFlights = [];

    const seatRequired = getValue(travelModes, `seat_preference`, false);
    const mealRequired = getValue(travelModes, `meal_preference`, false);

    if (seatRequired && (!request.seat_type || request.seat_type === "")) {
      invalidFlights.push("missing_seat_preference");
    }

    if (mealRequired && (!request.meal_type || request.meal_type === "")) {
      invalidFlights.push("missing_meal_preference");
    }

    return invalidFlights;
  };
  // Car rental validation function that handles ISO datetime strings
  const validateCars = (array: any[]) => {
    const invalidCars = array.filter((item: any) => {
      if (item.travel_mode !== "car") return false;

      const car = item.car;

      // Parse dates - handle both date-only and full ISO strings
      let pickUpDate, dropOffDate;
      let pickUpTime, dropOffTime;

      // Handle pick-up date and time
      try {
        pickUpDate = new Date(car.pick_up_date);

        // Handle if pick_up_time is a full ISO string or just time
        if (
          typeof car.pick_up_time === "string" &&
          car.pick_up_time.includes("T")
        ) {
          // It's a full ISO string
          pickUpTime = new Date(car.pick_up_time);
        } else {
          // It's just a time string like "15:00"
          const timeStr =
            typeof car.pick_up_time === "string" ? car.pick_up_time : "00:00";
          const [hours, minutes] = timeStr.split(":").map(Number);
          pickUpTime = new Date(pickUpDate);
          pickUpTime.setHours(hours, minutes, 0, 0);
        }
      } catch (e) {
        console.error("Error parsing pick-up date/time:", e);
        return true; // Consider invalid if we can't parse
      }

      // Handle drop-off date and time
      try {
        dropOffDate = new Date(car.drop_off_date);

        // Handle if drop_off_time is a full ISO string or just time
        if (
          typeof car.drop_off_time === "string" &&
          car.drop_off_time.includes("T")
        ) {
          // It's a full ISO string
          dropOffTime = new Date(car.drop_off_time);
        } else {
          // It's just a time string like "15:00"
          const timeStr =
            typeof car.drop_off_time === "string" ? car.drop_off_time : "00:00";
          const [hours, minutes] = timeStr.split(":").map(Number);
          dropOffTime = new Date(dropOffDate);
          dropOffTime.setHours(hours, minutes, 0, 0);
        }
      } catch (e) {
        console.error("Error parsing drop-off date/time:", e);
        return true; // Consider invalid if we can't parse
      }

      // Create combined date-time objects for comparison
      const fullPickUpDateTime = new Date(pickUpDate);
      const fullDropOffDateTime = new Date(dropOffDate);

      // Get time components
      const pickUpHours = pickUpTime.getHours();
      const pickUpMinutes = pickUpTime.getMinutes();
      const dropOffHours = dropOffTime.getHours();
      const dropOffMinutes = dropOffTime.getMinutes();

      // Set time components to the corresponding date objects
      fullPickUpDateTime.setHours(pickUpHours, pickUpMinutes, 0, 0);
      fullDropOffDateTime.setHours(dropOffHours, dropOffMinutes, 0, 0);

      // Debug logging
      // console.log("Car rental validation:", {
      //   carType: car.car_type || "Unknown car",
      //   pickUpDateTime: fullPickUpDateTime.toISOString(),
      //   dropOffDateTime: fullDropOffDateTime.toISOString(),
      //   isInvalid: fullDropOffDateTime <= fullPickUpDateTime
      // });

      // The validation check - drop-off datetime must be after pick-up datetime
      return fullDropOffDateTime <= fullPickUpDateTime;
    });

    return invalidCars;
  };

  const handleCreateTrip = async () => {
    // Check if itineraries exist
    if (
      (!itineraries || itineraries.length === 0) &&
      (!hotelItenaries || hotelItenaries.length === 0) &&
      (!carItenaries || carItenaries.length === 0) &&
      (!trainItenaries || trainItenaries.length === 0) &&
      (!busItenaries || busItenaries.length === 0)
    ) {
      toast.error(
        "Itineraries cannot be empty. Please add at least one itinerary.",
      );
      return;
    }

    // Validate flight seat and meal preferences if flights exist
    if (itineraries && itineraries.length > 0) {
      const invalidFlightPreferences = validateFlightPreferences(
        itineraries,
        request,
        travelModes,
      );
      if (invalidFlightPreferences.length > 0) {
        toast.error(
          "Seat preference and meal preference are mandatory for all flight bookings. Please complete all flight preferences.",
        );
        return;
      }
    }

    try {
      let form_payload = FormRequestHelper(form);
      let flight = generateFlightCreatePayload(
        getValue(request, `air_travel_type`, ""),
        itineraries,
        request,
      );
      let hotel = generateHotelPayload(hotelItenaries);
      let car = generateCarPayload(carItenaries, params);
      let train = generateTrainPayload(trainItenaries, params);
      let bus = generateBusPayload(busItenaries, params);
      let array = flight.concat(hotel, car, train, bus);

      // Validate multi-city flight details
      const multiCityFlights = array.filter(
        (item: any) =>
          item.travel_mode === "flight" &&
          item.air_travel_type === "multi_city",
      );

      for (let i = 0; i < multiCityFlights.length; i++) {
        for (let j = i + 1; j < multiCityFlights.length; j++) {
          const flight1 = multiCityFlights[i].flight;
          const flight2 = multiCityFlights[j].flight;

          if (
            flight1.departure_airport_code === flight2.departure_airport_code &&
            flight1.arrival_airport_code === flight2.arrival_airport_code &&
            flight1.departure_date === flight2.departure_date &&
            flight1.arrival_date === flight2.arrival_date &&
            flight1.time_preference === flight2.time_preference
          ) {
            toast.error(
              "The multi-city flights have the same travel details. Please update the itinerary.",
            );
            setSubmitLoading(false);
            return;
          }
        }
      }

      // Check if there are any multi-city flights
      if (multiCityFlights.length > 0) {
        // Ensure at least 2 flight itineraries for multi-city
        if (multiCityFlights.length < 2) {
          toast.error(
            "Multi-city travel requires at least two flight itineraries.",
          );
          setSubmitLoading(false);
          return;
        }
      }

      // Keep the existing duplicate check for multi-city flights
      for (let i = 0; i < multiCityFlights.length; i++) {
        for (let j = i + 1; j < multiCityFlights.length; j++) {
          const flight1 = multiCityFlights[i].flight;
          const flight2 = multiCityFlights[j].flight;

          if (
            flight1.departure_airport_code === flight2.departure_airport_code &&
            flight1.arrival_airport_code === flight2.arrival_airport_code &&
            flight1.departure_date === flight2.departure_date &&
            flight1.arrival_date === flight2.arrival_date &&
            flight1.time_preference === flight2.time_preference
          ) {
            toast.error("Duplicate flight details in multi-city itinerary");
            setSubmitLoading(false);
            return;
          }
        }
      }

      const invalidHotels = validateHotels(array);

      if (invalidHotels.length > 0) {
        toast.error(
          "Checkout time should not be earlier than or equal to checkin time in hotel itineraries.",
        );
        setSubmitLoading(false);
        return;
      }

      const invalidCars = validateCars(array);

      if (invalidCars.length > 0) {
        toast.error(
          "Drop Off time must be after Pick Up time. Please check your car rental details.",
        );
        setSubmitLoading(false);
        return;
      }

      // **Train Validation**
      const invalidTrains = array.filter(
        (item: any) =>
          item.travel_mode === "train" &&
          item.train.departure_city === item.train.arrival_city,
      );

      if (invalidTrains.length > 0) {
        toast.error(
          "Departure city and arrival city should not be the same in train itineraries.",
        );
        setSubmitLoading(false);
        return;
      }

      // **Bus Validation**
      const invalidBus = array.filter(
        (item: any) =>
          item.travel_mode === "bus" &&
          item.bus.departure_city === item.bus.arrival_city,
      );

      if (invalidBus.length > 0) {
        toast.error(
          "Departure city and arrival city should not be the same in Bus itineraries.",
        );
        setSubmitLoading(false);
        return;
      }

      let payload = {
        ...form_payload,
        itineraries: removeEmptyProperties(array),
        trip_documents: documents.map((doc: { id: string }) => doc.id),
      };

      if (
        !isEditMode() &&
        createdFor &&
        getValue(createdFor, `id`, "") !== "self"
      ) {
        payload.submitted_for = Number(getValue(createdFor, `id`, ""));
      }

      let resp;
      setTripLoading(true);

      if (getValue(params, `id`, "")) {
        resp = await updateTrip(
          getValue(params, `id`, ""),
          removeNullInObject(payload),
        );
      } else {
        resp = await createTrip(removeNullInObject(payload));
      }
      if (resp) {
        handleSubmitReport(getValue(resp, `data.id`, ""));
        hideValidation();
        setTripLoading(false);
      } else {
        setTripLoading(false);
        setIsOpen(false);
      }
    } catch (error) {
      setTripLoading(false);
    }
  };
  const hideValidation = () => {
    simpleValidator.current.fields = {};
    simpleValidator.current.hideMessages();
    forceUpdate(0);
  };

  /* --------------------------  Report Submission section  ----------------------- */

  const [isOpen, setIsOpen] = useState(false);
  const handleModal = () => {
    setIsOpen(!isOpen);
  };
  const [isWorkflowApprover, setIsWorkflowApprover] = useState(false);
  const [trip_id, setTrip_id] = useState("");
  const handleSubmitReport = async (id: string) => {
    try {
      setTrip_id(id);
      let resp = await getTripValidateApproverFlowType(id);
      if (resp) {
        setIsWorkflowApprover(getValue(resp, `data.isWorkflowApprover`, ""));
        if (getValue(resp, `data.isWorkflowApprover`, "")) {
          handleSubmitTrip(id);
        } else {
          handleModal();
        }
      }
    } catch (error) {}
  };
  const [submitTripLoading, setSubmitTripLoading] = useState(false);
  const [approverId, setApproverId] = useState("");
  const handleSubmitTrip = async (id: string) => {
    try {
      let requestPayload: any;
      if (isWorkflowApprover) {
        requestPayload = {
          id: id ? id : trip_id,
          comments: tripComments,
        };
      } else {
        requestPayload = {
          approver_id: approverId,
          id: id ? id : trip_id,
          comments: tripComments,
        };
      }
      if (
        !isEditMode() &&
        createdFor &&
        getValue(createdFor, `id`, "") !== "self"
      ) {
        requestPayload.submitted_for = Number(getValue(createdFor, `id`, ""));
      }
      setSubmitTripLoading(true);
      let resp = await submitTrip(
        removeNullOrUndefinedProperties(requestPayload),
      );
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        // if (!isWorkflowApprover) {
        //   handleModal();
        // }
        setIsOpen(false);
        setSubmitTripLoading(false);
        navigate(
          getValue(params, `id`, "")
            ? `/client/trips/detail/${getValue(params, `id`, "")}`
            : `/client/trips/`,
        );
      } else {
        setSubmitTripLoading(false);
      }
    } catch (error) {
      setSubmitTripLoading(false);
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                           Confirm Submit section                           */
  /* -------------------------------------------------------------------------- */
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const handleConfirmModal = () => {
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      // setCheckMandatoryModules(checkMandatoryFields());
      const mandatoryFields = checkMandatoryFields();
      setCheckMandatoryModules({});
      setTimeout(() => {
        setCheckMandatoryModules(mandatoryFields);
      }, 0);

      simpleValidator.current.showMessages();
      forceUpdate(1);
    } else {
      setIsConfirmOpen(!isConfirmOpen);
    }
  };
  const handleConfirmSubmit = () => {
    handleCreateTrip();
    handleConfirmModal();
  };

  const [activeTab, setActiveTab] = useState("info");

  function removeDuplicates(data: any) {
    if (getValue(data, `length`, 0) > 0) {
      // Identify all keys that have empty string values in any object
      let emptyStringKeys: any = new Set();
      data.forEach((obj: any) => {
        Object.keys(obj).forEach((key) => {
          if (obj[key] === "" || !obj[key]) {
            emptyStringKeys.add(key);
          }
        });
      });
      emptyStringKeys = Array.from(emptyStringKeys);
      // Convert each object to a JSON string to make them comparable and remove duplicates
      const uniqueData = new Set(data.map((item: any) => JSON.stringify(item)));
      // Convert the JSON strings back to objects
      const uniqueArray = Array.from(uniqueData).map((item: any) =>
        JSON.parse(item),
      );
      // Return the keys with empty string values if the array has objects, otherwise return an empty array
      if (uniqueArray.length > 0) {
        return emptyStringKeys;
      } else {
        return [];
      }
    } else {
      return [];
    }
  }

  const checkMandatoryFields = () => {
    const travelTypeValue = getValue(travelTypeField, `field_value`, "");
    const infoFields =
      getValue(form, `length`, 0) > 0
        ? form.filter((item: object) => getValue(item, `is_mandatory`, false))
        : [];

    const infoObjKeys =
      getValue(infoFields, `length`, 0) > 0
        ? infoFields.map((item: object) => getValue(item, `field_name`, ""))
        : [];

    if (
      travelTypeValue === "international" &&
      !infoObjKeys.includes("destination_country")
    ) {
      infoObjKeys.push("destination_country");
    }

    const flightObjKeys = [
      "departure_airport_code",
      "departure_date",
      "arrival_airport_code",
      "departure_time_preference",
      "departure_class",
      "seat_type", // Added mandatory seat preference
      "meal_type", // Added mandatory meal preference
    ];

    const flightRoundTripObjKeys = [
      "arrival_airport_code",
      "arrival_date",
      "arrival_class",
      "arrival_time_preference",
      "departure_airport_code",
      "departure_date",
      "departure_class",
      "departure_time_preference",
      "seat_type", // Added mandatory seat preference
      "meal_type", // Added mandatory meal preference
    ];

    const flightMultiCityObjKeys = [
      "arrival_airport_code",
      "departure_airport_code",
      "departure_date",
      "departure_class",
      "departure_time_preference",
      "seat_type", // Added mandatory seat preference
      "meal_type", // Added mandatory meal preference
    ];

    const hotelObjKeys = [
      "checkin_date",
      "checkin_time",
      "checkout_date",
      "checkout_time",
      "city",
    ];

    const carObjKeys = [
      "pick_up_location",
      "pick_up_date",
      "pick_up_time",
      "drop_off_location",
      "drop_off_date",
      "drop_off_time",
      "car_type",
      "is_driver_needed",
    ];

    const trainObjKeys = [
      "departure_date",
      "departure_city",
      "departure_city_name",
      "arrival_city",
      "arrival_city_name",
    ];

    const busObjKeys = [
      "departure_date",
      "departure_city",
      "departure_city_name",
      "arrival_city",
      "arrival_city_name",
    ];

    const infoFieldsMain = infoFields.map((item: any) => ({
      [item["field_name"]]: item["field_value"],
    }));

    const currentinfoObjKeys = removeDuplicates(infoFieldsMain);
    const currentflightObjKeys = removeDuplicates(itineraries);
    const currenthotelObjKeys = removeDuplicates(hotelItenaries);
    const currentcarObjKeys = removeDuplicates(carItenaries);
    const currenttrainObjKeys = removeDuplicates(trainItenaries);
    const currentbusObjKeys = removeDuplicates(busItenaries);

    const matchedInfo = currentinfoObjKeys.filter((item: string) =>
      infoObjKeys.includes(item),
    );

    const airTravelType = getValue(request, `air_travel_type`, "");
    const matchedFlight = (() => {
      switch (airTravelType) {
        case "one_way":
          return currentflightObjKeys.filter((item: string) =>
            flightObjKeys.includes(item),
          );
        case "round_trip":
          return currentflightObjKeys.filter((item: string) =>
            flightRoundTripObjKeys.includes(item),
          );
        default:
          return currentflightObjKeys.filter((item: string) =>
            flightMultiCityObjKeys.includes(item),
          );
      }
    })();

    const matchedHotel = currenthotelObjKeys.filter((item: string) =>
      hotelObjKeys.includes(item),
    );

    const matchedCar = currentcarObjKeys.filter((item: string) =>
      carObjKeys.includes(item),
    );

    const matchedTrain = currenttrainObjKeys.filter((item: string) =>
      trainObjKeys.includes(item),
    );

    const matchedBus = currentbusObjKeys.filter((item: string) =>
      busObjKeys.includes(item),
    );

    return {
      info: matchedInfo,
      flight: matchedFlight,
      hotel: matchedHotel,
      car: matchedCar,
      train: matchedTrain,
      bus: matchedBus,
    };
  };

  /* -------------------------------------------------------------------------- */
  /*                               Upload Section                                */
  /* -------------------------------------------------------------------------- */
  const fileTypes = ["PDF", "JPEG", "XLSX", "CSV", "XLSM", "XLX", "JPG", "PNG"];
  const handleUploadDocuments = async (e: any) => {
    Array.from(e).forEach(async (item: any) => {
      let formData = new FormData();
      formData.append("file", item);
      try {
        let resp = await mediaUpload(formData);
        if (resp) {
          setDocuments((prevDocuments: any) => [
            ...prevDocuments,
            getValue(resp, `data`, {}),
          ]);
          e = null;
        } else {
          e = null;
        }
      } catch (error) {
        e = null;
      }
    });
  };

  const handleRemoveDocuments = (index: number) => {
    let list = documents.filter((_item: object, i: number) => index !== i);
    setDocuments(list);
  };

  const getCreatedForLabel = () => {
    if (!isEditMode()) {
      return "Created For";
    }
    console.log(isCurrentUserSubmitter, "pop");

    if (isCurrentUserSubmitter) {
      return "Created For";
    }

    return "Created By";
  };
  // const shouldDisableCreatedForDropdown = () => {
  //   return isEditMode(); // Always disable in edit mode
  // };

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes("trips") ? (
        <NoAccessPage />
      ) : (
        <>
          <CreateTripsStickyHeader
            route={
              getValue(params, `id`, "")
                ? `/client/trips/detail/${getValue(params, `id`, "")}`
                : `/client/trips/`
            }
            submitLoading={submitLoading}
            handleSubmit={handleSubmit}
            handleCreateTrip={handleConfirmModal}
            tripLoading={tripLoading}
            id={getValue(params, `id`, "")}
            permissions={getValue(props, `permissions`, [])}
          />
          <TripsTabNavigation
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            flightList={itineraries}
            hotelList={hotelItenaries}
            carList={carItenaries}
            trainList={trainItenaries}
            busList={busItenaries}
            request={request}
            travelModes={travelModes}
            checkMandatoryModules={checkMandatoryModules}
          />
          <div className="trips_main_section">
            <div className="trips_flights_cotnainer">
              {activeTab === "info" && (
                <>
                  <div className="form_flex_container">
                    <div className="form_trips_wrapper">
                      {createdForOptions.length > 1 &&
                        getValue(createdFor, `id`, "") !== "self" && (
                          <div className="form_trips_wrapper_container">
                            <SingleSelectSearchDropdown
                              name={getCreatedForLabel()}
                              showLabel={true}
                              mandatory={true}
                              placeholder={`Select ${getCreatedForLabel().toLowerCase()}`}
                              value={getValue(createdFor, `id`, "")}
                              data={createdForOptions}
                              label="label"
                              selectKey="id"
                              width="100%"
                              disabled={true}
                              onChange={(option: any) => {
                                if (!isEditMode()) {
                                  setCreatedFor(option);
                                }
                              }}
                            />
                          </div>
                        )}

                      {getValue(form, `length`, 0) > 0
                        ? form.map((item: any, index: number) => {
                            let travel_type = form.filter(
                              (item: object) =>
                                getValue(item, `field_name`, "") ===
                                "travel_type",
                            );
                            const isInternationalTrip =
                              getValue(
                                travel_type,
                                `[${0}].field_value`,
                                "",
                              ) === "international";

                            if (
                              getValue(travel_type, `length`, 0) > 0 &&
                              (getValue(
                                travel_type,
                                `[${0}].field_value`,
                                "",
                              ) === "domestic"
                                ? getValue(item, `field_name`, false) !==
                                    "destination_country" &&
                                  getValue(item, `field_name`, false) !==
                                    "is_visa_required"
                                : getValue(item, `field_name`, false))
                            )
                              if (getValue(item, `is_visible`, false))
                                return (
                                  <div
                                    className="form_trips_wrapper_container"
                                    key={index}
                                  >
                                    <RenderForm
                                      item={
                                        getValue(item, `field_name`, "") ===
                                          "destination_country" &&
                                        isInternationalTrip
                                          ? {
                                              ...item,
                                              is_mandatory: true,
                                            }
                                          : item
                                      }
                                      setFields={setForm}
                                      index={index}
                                      simpleValidator={simpleValidator}
                                      tripLimit={tripLimit}
                                      formOptions={formOptions}
                                    />
                                  </div>
                                );
                          })
                        : null}

                      {getValue(form, `length`, 0) > 0
                        ? form.map((item: any, index: number) => {
                            let travel_type = form.filter(
                              (item: object) =>
                                getValue(item, `field_name`, "") ===
                                "travel_type",
                            );
                            const getDestinationCountryValue = (form: any) => {
                              const destinationField = form.find(
                                (item_form: any) =>
                                  item_form.field_name ===
                                  "destination_country",
                              );
                              return destinationField?.field_value || "";
                            };

                            const destinationValue =
                              getDestinationCountryValue(form);
                            if (
                              getValue(
                                travel_type,
                                `[${0}].field_value`,
                                "",
                              ) === "international"
                            )
                              return (
                                <>
                                  {item.field_name === "travel_type" &&
                                    item.field_value === "international" &&
                                    destinationValue && (
                                      <div className="international-docs d-flex gap-3 w-100">
                                        {/* {travelDoucmentsUser} */}
                                        {travelDocumentsUser ? (
                                          <>
                                            {passportDetails ? (
                                              <div className="card p-2 w-50 passport-card-wrap">
                                                <b className="mb-2 border-bottom pb-2">
                                                  Passport
                                                </b>
                                                {/* {travelDocumentsUser.passport.map(
                                                  (passport, index) => (
                                                    
                                                  )
                                                )} */}
                                                {
                                                  <>
                                                    <div className="passport-section-holder">
                                                      <div className="d-flex align-items-center justify-content-between">
                                                        <div className="doc-name mb-2">
                                                          <label>
                                                            Name of Applicant
                                                          </label>
                                                          <div className="value-holder">
                                                            {formatText(
                                                              getValue(
                                                                passportDetails,
                                                                `user.first_name`,
                                                                "",
                                                              ),
                                                            )}{" "}
                                                            {""}
                                                            {formatText(
                                                              getValue(
                                                                passportDetails,
                                                                `user.middle_name`,
                                                                "",
                                                              ),
                                                            )}{" "}
                                                            {""}
                                                            {formatText(
                                                              getValue(
                                                                passportDetails,
                                                                `user.last_name`,
                                                                "",
                                                              ),
                                                            )}
                                                          </div>
                                                        </div>

                                                        <div className="conent-wrap">
                                                          <label>
                                                            Document No :
                                                          </label>
                                                          <div>
                                                            <div className="value-holder">
                                                              {getValue(
                                                                passportDetails,
                                                                `document_number`,
                                                                "",
                                                              )}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>

                                                      <div className="d-flex align-items-center gap-4">
                                                        <div className="conent-wrap">
                                                          <label>
                                                            Valid From :
                                                          </label>
                                                          <div>
                                                            <div className="value-holder">
                                                              {convertDateAsString(
                                                                getValue(
                                                                  passportDetails,
                                                                  `document_valid_from`,
                                                                  "",
                                                                ),
                                                              )}
                                                            </div>
                                                          </div>
                                                        </div>

                                                        <div className="conent-wrap">
                                                          <label>
                                                            Valid Till :
                                                          </label>
                                                          <div>
                                                            <div className="value-holder">
                                                              {convertDateAsString(
                                                                getValue(
                                                                  passportDetails,
                                                                  `document_expires_on`,
                                                                  "",
                                                                ),
                                                              )}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </>
                                                }
                                              </div>
                                            ) : (
                                              <div className="card p-2 w-50 passport-card-wrap">
                                                <b className="mb-2 border-bottom pb-2">
                                                  Passport
                                                </b>

                                                <div className="d-flex align-items-center justify-content-between">
                                                  <p>Passport not found</p>

                                                  {!createdFor && (
                                                    <NavLink
                                                      to={`/client/settings/travel-documents`}
                                                      target="_blank"
                                                    >
                                                      {/* <button className="ascent-button ascent-button--header-buttons ascent-button--primary"> */}
                                                      Add Passport
                                                      {/* </button> */}
                                                    </NavLink>
                                                  )}
                                                </div>
                                              </div>
                                            )}

                                            {travelDocumentsUser.visa.length >
                                            0 ? (
                                              <div className="card p-2 w-50 passport-card-wrap">
                                                <b className="mb-2 border-bottom pb-2">
                                                  Visa
                                                </b>
                                                {travelDocumentsUser.visa.map(
                                                  (visa, index) => (
                                                    <>
                                                      <div className="passport-section-holder">
                                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                                          <div className="doc-name ">
                                                            <label>
                                                              Name of Applicant
                                                            </label>
                                                            <div className="value-holder">
                                                              {formatText(
                                                                getValue(
                                                                  visa,
                                                                  `user.first_name`,
                                                                  "",
                                                                ),
                                                              )}{" "}
                                                              {""}
                                                              {formatText(
                                                                getValue(
                                                                  visa,
                                                                  `user.middle_name`,
                                                                  "",
                                                                ),
                                                              )}{" "}
                                                              {""}
                                                              {formatText(
                                                                getValue(
                                                                  visa,
                                                                  `user.last_name`,
                                                                  "",
                                                                ),
                                                              )}
                                                            </div>
                                                          </div>

                                                          <div className="conent-wrap">
                                                            <label>
                                                              Document No :
                                                            </label>
                                                            <div>
                                                              <div className="value-holder">
                                                                {getValue(
                                                                  visa,
                                                                  `document_number`,
                                                                  "",
                                                                )}
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>

                                                        <div className="d-flex align-items-center gap-4 mb-2">
                                                          <div className="conent-wrap">
                                                            <label>
                                                              Valid From :
                                                            </label>
                                                            <div>
                                                              <div className="value-holder">
                                                                {convertDateAsString(
                                                                  getValue(
                                                                    visa,
                                                                    `document_valid_from`,
                                                                    "",
                                                                  ),
                                                                )}
                                                              </div>
                                                            </div>
                                                          </div>

                                                          <div className="conent-wrap">
                                                            <label>
                                                              Valid Till :
                                                            </label>
                                                            <div>
                                                              <div className="value-holder">
                                                                {convertDateAsString(
                                                                  getValue(
                                                                    visa,
                                                                    `document_expires_on`,
                                                                    "",
                                                                  ),
                                                                )}
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>

                                                        <div className="d-flex align-items-center gap-4">
                                                          <div className="conent-wrap">
                                                            <label>
                                                              Issuing Country :
                                                            </label>
                                                            <div>
                                                              <div className="value-holder">
                                                                {formatText(
                                                                  getValue(
                                                                    visa,
                                                                    `document_country.name`,
                                                                    "",
                                                                  ),
                                                                )}
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </>
                                                  ),
                                                )}
                                              </div>
                                            ) : (
                                              <div className="card p-2 w-50 passport-card-wrap">
                                                <b className="mb-2 border-bottom pb-2">
                                                  Visa
                                                </b>

                                                <div className="d-flex align-items-center justify-content-between">
                                                  <p>Visa not found</p>

                                                  {!createdFor && (
                                                    <NavLink
                                                      to={`/client/settings/travel-documents`}
                                                      target="_blank"
                                                    >
                                                      {/* <button className="ascent-button ascent-button--header-buttons ascent-button--primary"> */}
                                                      Add Visa
                                                      {/* </button> */}
                                                    </NavLink>
                                                  )}
                                                </div>
                                              </div>
                                            )}
                                          </>
                                        ) : (
                                          <p>Loading travel documents...</p>
                                        )}
                                      </div>
                                    )}
                                </>
                              );
                          })
                        : null}
                    </div>
                  </div>

                  <div style={{ width: "70%", margin: "0 auto" }}>
                    <div className="trip-upload-doc mt-4">
                      <DragAndDropFileComponent
                        uploadFile={handleUploadDocuments}
                        name="file"
                        types={fileTypes}
                        multiple
                        classes="bulk-upload_drag-n-drop-wrapper position-absolute"
                        fileName={getValue(props, `importedFile.name`, "")}
                        setImportTedFile={props.setImportTedFile}
                      />

                      {getValue(documents, `length`, 0) > 0 &&
                        documents.map((item: object, index: number) => {
                          return (
                            <div className="d-flex align-items-center ">
                              <div className="p-2 border border-radius__5 d-flex align-items-center w-100 mt-2">
                                <div>
                                  <FileLogSvgComponent />
                                </div>
                                <p className="small_text__16 ms-2">
                                  {concatString(getValue(item, `name`, ""), 30)}
                                  {getValue(item, `extension`, "")}
                                </p>
                              </div>
                              <div
                                className="mx-2"
                                onClick={() => handleRemoveDocuments(index)}
                              >
                                <DeleteSvgComponent />
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </>
              )}

              {activeTab === "flight" &&
                getValue(travelModes, `flight_reservation`, false) && (
                  <>
                    <TripsCreateFlightList
                      request={request}
                      itineraries={itineraries}
                      setItenaries={setItenaries}
                      validator={simpleValidator}
                      setRequest={setRequest}
                      hideValidation={hideValidation}
                      travelModes={travelModes}
                      flightPreference={flightPreference}
                    />
                  </>
                )}
              {activeTab === "hotel" &&
                getValue(travelModes, `hotel_reservation`, false) && (
                  <>
                    <TripCreateHotelSection
                      hotelItenaries={hotelItenaries}
                      setHotelItenaries={setHotelItenaries}
                      validator={simpleValidator}
                      hideValidation={hideValidation}
                    />
                  </>
                )}

              {activeTab === "car" &&
                getValue(travelModes, `car_rental`, false) && (
                  <>
                    <TripCreateCarSection
                      itenaries={carItenaries}
                      setItenaries={setCarItenaries}
                      validator={simpleValidator}
                      hideValidation={hideValidation}
                    />
                  </>
                )}
              {activeTab === "train" &&
                getValue(travelModes, `train`, false) && (
                  <>
                    <TripCreateTrainSection
                      itenaries={trainItenaries}
                      setItenaries={setTrainItenaries}
                      validator={simpleValidator}
                      hideValidation={hideValidation}
                    />
                  </>
                )}
              {activeTab === "bus" && getValue(travelModes, `bus`, false) && (
                <>
                  <TripCreateBusSection
                    itenaries={busItenaries}
                    setItenaries={setBusItenaries}
                    validator={simpleValidator}
                    hideValidation={hideValidation}
                  />
                </>
              )}
            </div>
          </div>
          <ReportSubmitModal
            isOpen={isOpen}
            handleModal={handleModal}
            handleSubmit={handleSubmitTrip}
            approverId={approverId}
            setApproverId={setApproverId}
            submitLoading={submitTripLoading}
            comment={tripComments}
            setComment={setTripComments}
          />
          <SubmitConfirmModalWithComments
            isOpen={isConfirmOpen}
            handleModal={handleConfirmModal}
            handleSubmit={handleConfirmSubmit}
            submitLoading={submitTripLoading}
            comment={tripComments}
            setComment={setTripComments}
          />
        </>
      )}
    </DashboardLayout>
  );
}

export default ClientTripsCreate;
